// Set to track preload errors - used by ErrorBoundary to detect chunk loading failures
export const chunkPreloadErrors = new Set<Error>();

const RELOAD_KEY_PREFIX = 'chunk-reload-';

export function setupPreloadErrorHandler(): void {
  globalThis.addEventListener('vite:preloadError', (event: VitePreloadErrorEvent) => {
    console.log('Preload error detected:', event.payload);
    chunkPreloadErrors.add(event.payload);
  });
}

export function markChunkLoaded(chunkName: string): void {
  sessionStorage.removeItem(RELOAD_KEY_PREFIX + chunkName);
}

export function handleChunkLoadError(chunkName: string): boolean {
  const key = RELOAD_KEY_PREFIX + chunkName;
  const hasAttemptedReload = sessionStorage.getItem(key);

  if (hasAttemptedReload) {
    return false;
  }

  console.log(`[ChunkLoader] 🔄 First failure for "${chunkName}", triggering page reload...`);
  sessionStorage.setItem(key, 'true');
  globalThis.location.reload();
  return true;
}
